import originalPosthog from 'posthog-js';

// shim to curb error that may occur when posthog is not set up locally
export const posthog = (process.env.POSTHOG_ENABLED && process.env.POSTHOG_API_KEY)
  ? originalPosthog
  : undefined;
